import React, { Suspense } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import bannerImg1 from '../../assets/images/builders/builderBanner/img1.webp'
import bannerImg2 from '../../assets/images/builders/builderBanner/img2.webp'
import bannerImg3 from '../../assets/images/builders/builderBanner/img3.webp'
function InnerBuilderBanner() {

    const settings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024, // Large devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600, // Medium devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480, // Small devices
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    };

  return (
    <>
        <div className="innerBuilderBanner">
            <Slider {...settings}>
                <Suspense>
                    <div className="innerBuilderBannerBox">
                        <img src={bannerImg1} alt="" />
                    </div>
                </Suspense>
                <Suspense>
                    <div className="innerBuilderBannerBox">
                        <img src={bannerImg2} alt="" />
                    </div>
                </Suspense>
                <Suspense>
                    <div className="innerBuilderBannerBox">
                        <img src={bannerImg3} alt="" />
                    </div>
                </Suspense>
            </Slider>
        </div>
    </>
  );
}

export default InnerBuilderBanner;
